import { Component, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-sdk-install-info-dialog',
  imports: [Button],
  templateUrl: './sdk-install-info-dialog.html',
  styleUrl: './sdk-install-info-dialog.scss',
})
export class SdkInstallInfoDialog {
  protected readonly dynamicDialogRef = inject(DynamicDialogRef);
}
